:root {
  --g-top-bar-height: 48px;
  --g-mobile-top: 59px;
  --g-mobile-bottom: 94px;
  --g-mobile-preview-max-height: 512px; }

._mobileWizard_s0m6t_7 {
  position: absolute;
  width: 100%;
  height: 100%; }
  ._mobileWizard_s0m6t_7 ._mobileWizardLeftHalf_s0m6t_11 {
    position: relative;
    transition: transform 1.7s cubic-bezier(0.4, 0, 0.2, 1);
    transform: translateX(-100%);
    box-sizing: border-box;
    text-align: center;
    background: #fff;
    width: 50%;
    left: 0;
    top: 0;
    height: 100%;
    min-width: 640px; }
  ._mobileWizard_s0m6t_7 ._mobileWizardTopBar_s0m6t_23 {
    transition: opacity 1.7s ease-in-out;
    opacity: 0;
    width: 100%;
    height: 48px;
    position: absolute;
    top: 0;
    z-index: 1; }
    ._mobileWizard_s0m6t_7 ._mobileWizardTopBar_s0m6t_23 ._topBarLeftWixLogo_s0m6t_31 {
      border-right: none;
      position: absolute;
      left: 23px;
      top: 15px; }
    ._mobileWizard_s0m6t_7 ._mobileWizardTopBar_s0m6t_23 ._mobileWizardTopBarSkip_s0m6t_36 {
      position: absolute;
      font-size: 16px;
      top: 28px;
      right: 36px; }
  ._mobileWizard_s0m6t_7._mobileWizardExpanded_s0m6t_41 ._mobileWizardLeftHalf_s0m6t_11 {
    transform: translateX(0); }
  ._mobileWizard_s0m6t_7._mobileWizardExpanded_s0m6t_41 ._mobileWizardTopBar_s0m6t_23 {
    opacity: 1; }
  ._mobileWizard_s0m6t_7 ._mobileWizardInner_s0m6t_45 {
    top: calc( 50% - 247.5px - 36px);
    position: relative; }
    ._mobileWizard_s0m6t_7 ._mobileWizardInner_s0m6t_45::after {
      content: '';
      border-right: 1px solid #d3edff;
      position: absolute;
      width: 0;
      height: 608px;
      top: 0;
      right: 0; }
    ._mobileWizard_s0m6t_7 ._mobileWizardInner_s0m6t_45 ._currentStepContainer_s0m6t_56 {
      min-height: 400px;
      max-width: 542px;
      margin: auto;
      width: 100%;
      box-sizing: border-box;
      padding: 12px 0; }
    ._mobileWizard_s0m6t_7 ._mobileWizardInner_s0m6t_45 ._mobileWizardActions_s0m6t_63 {
      justify-content: center; }
      ._mobileWizard_s0m6t_7 ._mobileWizardInner_s0m6t_45 ._mobileWizardActions_s0m6t_63 button:first-of-type {
        margin-left: 0; }

@keyframes _fade-in_s0m6t_1 {
  from {
    opacity: 0; }
  to {
    opacity: 1; } }

body {
  overflow-y: hidden; }
  ._sections-experience_s0m6t_76 body {
    overflow-x: hidden; }

#_preview_s0m6t_134 {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  border: 0;
  overflow: hidden; }

._editor-animation-manager-wrapper_s0m6t_87 {
  position: relative;
  height: 100vh;
  width: 100vw; }

._editor-layout-wrapper_s0m6t_92 {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  z-index: 0;
  background: initial !important; }
  ._editor-layout-wrapper_s0m6t_92._zoom-mode_s0m6t_99 {
    background: #f7f8f8; }

._editor-layout-header_s0m6t_102 {
  flex: 0 0 auto; }

._editor-layout-body_s0m6t_105 {
  position: relative;
  flex: 1 0 0;
  min-height: 0;
  overflow: hidden; }

._editor-layout-splitter-row_s0m6t_111 {
  display: flex;
  flex-direction: row;
  height: 100%; }
  ._editor-layout-splitter-row_s0m6t_111::before {
    content: '';
    height: 100%;
    width: var(--stage-scrollbar-width);
    position: absolute;
    top: 0;
    right: 0;
    background-color: #fafafa; }

._editor-layout-left-bar_s0m6t_124 {
  background-color: var(--bodyBackgroundColor);
  position: relative;
  flex: 0 0 auto;
  transition: 0.6s cubic-bezier(0.645, 0.045, 0.355, 1) width; }
  ._sections-experience_s0m6t_76 ._editor-layout-left-bar_s0m6t_124 {
    width: var(--left-bar-width); }
  ._tools-hidden_s0m6t_131 ._editor-layout-left-bar_s0m6t_124 {
    width: 0; }
  ._editor-layout-left-bar_s0m6t_124._expanded_s0m6t_133,
  ._previewMode_s0m6t_134 ._editor-layout-left-bar_s0m6t_124 {
    width: auto; }
  ._editor-layout-left-bar_s0m6t_124._left-panel-hidden-elements-redesign-experiment_s0m6t_136 button._hidden-items-panel_s0m6t_136 span {
    background-color: #116dff; }

._editor-content-wrapper_s0m6t_139 {
  position: relative;
  top: 0;
  height: 100%;
  transition: 0.6s cubic-bezier(0.645, 0.045, 0.355, 1) top, 0.6s cubic-bezier(0.645, 0.045, 0.355, 1) height; }
  ._editor-content-wrapper_s0m6t_139 ._secondary-left-area_s0m6t_144 {
    z-index: 10;
    overflow: hidden;
    border-right: 1px solid #b6c1cd; }
  ._editor-content-wrapper_s0m6t_139._tools-hidden_s0m6t_131 {
    transition: 0.4s cubic-bezier(0.645, 0.045, 0.355, 1) top, 0.4s cubic-bezier(0.645, 0.045, 0.355, 1) height; }
  ._editor-content-wrapper_s0m6t_139 ._splitter_s0m6t_150 {
    height: 100%;
    width: 100%; }
  ._editor-content-wrapper_s0m6t_139 ._wix-code-left-pane_s0m6t_153 {
    -webkit-user-select: none;
    user-select: none;
    z-index: 1072;
    position: relative; }
    ._classic-facelift-skin_s0m6t_160 ._editor-content-wrapper_s0m6t_139 ._wix-code-left-pane_s0m6t_153 {
      z-index: 1444; }
  ._editor-content-wrapper_s0m6t_139 ._wix-code-ide-pane_s0m6t_162 {
    -webkit-user-select: none;
    user-select: none;
    box-shadow: 10px 0 16px 0 rgba(0, 0, 0, 0.14);
    z-index: 1071; }
    ._editor-content-wrapper_s0m6t_139 ._wix-code-ide-pane_s0m6t_162._above-editor_s0m6t_169 {
      z-index: 1440; }
  ._editor-content-wrapper_s0m6t_139 ._right-pane_s0m6t_171 {
    z-index: 1085; }
    ._editor-content-wrapper_s0m6t_139 ._right-pane_s0m6t_171._right-pane-above-modals_s0m6t_173 {
      z-index: 6002; }
    ._classic-facelift-skin_s0m6t_160 ._editor-content-wrapper_s0m6t_139 ._right-pane_s0m6t_171 {
      border-top: 1px solid #dfe5eb;
      box-sizing: border-box; }
  ._editor-content-wrapper_s0m6t_139 ._ide-splitter_s0m6t_178 ._splitter-divider_s0m6t_178 {
    z-index: 1070; }
  ._editor-content-wrapper_s0m6t_139 ._file-pane-splitter_s0m6t_180 ._splitter-divider-handle_s0m6t_180 {
    display: none; }
  ._editor-content-wrapper_s0m6t_139 ._file-pane-splitter_s0m6t_180._file-pane-splitter-pane-0-closed_s0m6t_182 > ._splitter-divider_s0m6t_178 {
    pointer-events: none; }
  ._editor-content-wrapper_s0m6t_139 ._file-pane-splitter_s0m6t_180._file-pane-splitter-pane-0-hover_s0m6t_184 ._splitter-divider-handle_s0m6t_180:not(._closed_s0m6t_184), ._editor-content-wrapper_s0m6t_139 ._file-pane-splitter_s0m6t_180._file-pane-splitter-divider-hover_s0m6t_184 ._splitter-divider-handle_s0m6t_180:not(._closed_s0m6t_184) {
    display: block; }

._classic-facelift-skin_s0m6t_160 ._corvid-site-structure_s0m6t_187 {
  border-top: 1px solid #dfe5eb;
  box-sizing: border-box; }

._classic-facelift-skin_s0m6t_160 ._wix-code-ide-pane_s0m6t_162 {
  border-top: 1px solid #dfe5eb;
  box-sizing: border-box; }

._classic-facelift-skin_s0m6t_160 ._top-bar-wrapper_s0m6t_195 > ._next-main-top-bar_s0m6t_195 {
  box-shadow: none; }

._infiniteEditorLayoutEditingArea_s0m6t_198 {
  position: relative;
  flex: 1 0 0;
  height: 100%; }
  ._infiniteEditorLayoutEditingArea_s0m6t_198._truncated_s0m6t_202 {
    margin-right: calc( var(--stage-right-margin) + var(--stage-scrollbar-width));
    box-shadow: 0px -1px 8px 2px rgba(0, 0, 0, 0.08), 0px 1px 8px 2px rgba(0, 0, 0, 0.08), 2px 0px 8px 2px rgba(0, 0, 0, 0.08), -2px 0px 8px 2px rgba(0, 0, 0, 0.08); }
  ._infiniteEditorLayoutEditingArea_s0m6t_198:before {
    z-index: 1450;
    content: '';
    position: absolute;
    left: 0;
    right: calc(var(--stage-right-margin) * -1);
    top: -30px;
    height: 30px;
    -webkit-clip-path: inset(30px 0 -20px 0);
            clip-path: inset(30px 0 -20px 0);
    box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 2px 10px 0 rgba(0, 0, 0, 0.08), 0 1px 20px 0 rgba(0, 0, 0, 0.08);
    pointer-events: none; }

._infiniteEditingArea_s0m6t_217 {
  position: absolute;
  height: 100%;
  width: 100%;
  background: initial !important;
  --g-mobile-top: 18px;
  --g-mobile-bottom: 18px;
  --g-mobile-preview-max-height: 568px; }
  ._infiniteEditingArea_s0m6t_217._mobileWizardEditingArea_s0m6t_225 {
    overflow: hidden;
    background-color: #fff; }
  ._infiniteEditingArea_s0m6t_217._infiniteEditingAreaMobileEditor_s0m6t_228 {
    background-color: #f7f8f8;
    transition: background-color 1.4s ease-in-out; }
  ._infiniteEditingArea_s0m6t_217._noBoxShadow_s0m6t_231 {
    box-shadow: none; }
  ._infiniteEditingArea_s0m6t_217._newMobileEditorLayoutWithStageBanner_s0m6t_233 {
    --g-mobile-top: calc(
      18px + var(--stage-top)
    ); }

._previewFrameCover_s0m6t_238 {
  position: absolute;
  top: var(--stage-top);
  height: calc(100% - var(--stage-top) - var(--stage-bottom));
  width: 100%; }
  ._previewFrameCover_s0m6t_238._previewFrameCoverStageZoomMode_s0m6t_243 {
    top: var(--stage-top);
    height: calc(100% - var(--stage-top) - var(--stage-bottom)); }
  ._previewFrameCover_s0m6t_238._previewFrameCoverMobileEditor_s0m6t_246 {
    top: var(--g-mobile-top);
    height: calc(100% - var(--g-mobile-top) - var(--g-mobile-bottom)); }
    ._previewFrameCover_s0m6t_238._previewFrameCoverMobileEditor_s0m6t_246._previewFrameCoverPreviewMode_s0m6t_249 {
      max-height: var(--g-mobile-preview-max-height);
      top: 50%;
      transform: translateY(-50%); }
    ._previewFrameCover_s0m6t_238._previewFrameCoverMobileEditor_s0m6t_246._previewFrameCoverMobileWizard_s0m6t_253 {
      animation: _mobile-frame-wizard-animation_s0m6t_1 3s;
      animation-iteration-count: 1;
      animation-timing-function: ease-in-out;
      animation-fill-mode: forwards; }
    ._previewFrameCover_s0m6t_238._previewFrameCoverMobileEditor_s0m6t_246._previewFrameCoverMobileWizardOut_s0m6t_258 {
      animation: _mobile-frame-wizard-out-animation_s0m6t_1 2s;
      animation-iteration-count: 1;
      animation-timing-function: ease-in-out;
      animation-fill-mode: forwards; }
  ._previewFrameCover_s0m6t_238._desktopZoomModeOldTopBar_s0m6t_263 {
    top: 37px;
    height: calc(100% - 37px); }

@keyframes _mobile-frame-wizard-animation_s0m6t_1 {
  0% {
    top: var(--g-mobile-top);
    margin-top: 0;
    max-height: 100%;
    left: 0;
    width: 100%;
    opacity: 1; }
  33% {
    top: var(--g-mobile-top);
    margin-top: 0;
    max-height: 100%;
    left: 0;
    width: 100%;
    opacity: 0; }
  66% {
    top: 50%;
    margin-top: calc(var(--g-mobile-preview-max-height) / -2);
    max-height: var(--g-mobile-preview-max-height);
    left: 50%;
    width: 50%;
    opacity: 0; }
  100% {
    top: 50%;
    margin-top: calc(var(--g-mobile-preview-max-height) / -2);
    max-height: var(--g-mobile-preview-max-height);
    left: 50%;
    width: 50%;
    opacity: 1; } }

@media (max-width: 1280px) {
  @keyframes _mobile-frame-wizard-animation_s0m6t_1 {
    0% {
      top: var(--g-mobile-top);
      margin-top: 0;
      max-height: 100%;
      left: 0;
      width: 100%;
      opacity: 1; }
    33% {
      top: var(--g-mobile-top);
      margin-top: 0;
      max-height: 100%;
      left: 0;
      width: 100%;
      opacity: 0; }
    66% {
      top: 50%;
      margin-top: calc(var(--g-mobile-preview-max-height) / -2);
      max-height: var(--g-mobile-preview-max-height);
      width: calc(100% - 640px);
      left: 640px;
      opacity: 0; }
    100% {
      top: 50%;
      margin-top: calc(var(--g-mobile-preview-max-height) / -2);
      max-height: var(--g-mobile-preview-max-height);
      width: calc(100% - 640px);
      left: 640px;
      opacity: 1; } } }

@keyframes _mobile-frame-wizard-out-animation_s0m6t_1 {
  0% {
    top: 50%;
    margin-top: calc(var(--g-mobile-preview-max-height) / -2);
    max-height: var(--g-mobile-preview-max-height);
    left: 50%;
    width: 50%;
    opacity: 1; }
  33% {
    top: 50%;
    margin-top: calc(var(--g-mobile-preview-max-height) / -2);
    max-height: var(--g-mobile-preview-max-height);
    left: 50%;
    width: 50%;
    opacity: 0; }
  66% {
    top: var(--g-mobile-top);
    margin-top: 0;
    max-height: 100%;
    left: 0;
    width: 100%;
    opacity: 0; }
  100% {
    top: var(--g-mobile-top);
    margin-top: 0;
    max-height: 100%;
    left: 0;
    width: 100%;
    opacity: 1; } }

@media (max-width: 1280px) {
  @keyframes _mobile-frame-wizard-out-animation_s0m6t_1 {
    0% {
      top: 50%;
      margin-top: calc(var(--g-mobile-preview-max-height) / -2);
      max-height: var(--g-mobile-preview-max-height);
      width: calc(100% - 640px);
      left: 640px;
      opacity: 1; }
    33% {
      top: 50%;
      margin-top: calc(var(--g-mobile-preview-max-height) / -2);
      max-height: var(--g-mobile-preview-max-height);
      width: calc(100% - 640px);
      left: 640px;
      opacity: 0; }
    66% {
      top: var(--g-mobile-top);
      margin-top: 0;
      max-height: 100%;
      left: 0;
      width: 100%;
      opacity: 0; }
    100% {
      top: var(--g-mobile-top);
      margin-top: 0;
      max-height: 100%;
      left: 0;
      width: 100%;
      opacity: 1; } } }

._previewWidthInfo_s0m6t_389 {
  left: 0;
  text-align: center;
  padding-top: 12px;
  position: -webkit-sticky;
  position: sticky; }
